import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { NavigateService } from '../../services/navigate/navigate.service';
import { StorageService } from '../../services/storage/storage.service';
import { LoginType } from '../../enum/global-enum';
import { TYPE } from '../../constants/Constant';

@Injectable()
export class EnrolRouteGuard implements CanActivate {
  constructor(
    private storage:StorageService) {}

  canActivate(): boolean {
    let loginType = this.storage.getItem(TYPE) 
    if(loginType == LoginType.Enrol){
        return true;
    }
    
    return false;
  }
  
}